import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";

const BottomCtaModule = () => {
  return (
    <div className="mt-6 rounded-md border border-purple-100 bg-white p-5 shadow-sm sm:p-6">
      <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex gap-4">
          <span className="grid h-12 w-12 shrink-0 place-items-center rounded-sm bg-[rgba(126,34,206,0.08)] text-[rgb(126,34,206)]">
            <Sparkles className="h-6 w-6" aria-hidden="true" />
          </span>
          <div>
            <p className="text-sm font-semibold uppercase text-[rgb(126,34,206)]">
              Prep smarter
            </p>
            <h5 className="mt-1 text-lg font-extrabold text-gray-900">
              Enjoy a smarter PTE preparation experience with advanced AI
              features
            </h5>
            <a
              className="mt-2 inline-block text-sm font-semibold text-[rgb(126,34,206)] hover:underline"
              href="/what-is-pte"
            >
              What is a PTE?
            </a>
          </div>
        </div>

        <a
          className="inline-flex shrink-0 items-center justify-center gap-2 rounded-sm bg-[rgba(126,34,206,0.08)] px-5 py-3 text-sm font-semibold text-[rgb(126,34,206)] ring-1 ring-[rgba(126,34,206,0.16)] transition hover:bg-[rgba(126,34,206,0.12)]"
          href="/signup"
        >
          <Sparkles className="h-4 w-4" aria-hidden="true" />
          Get Free Trial
          <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </a>
      </div>
    </div>
  );
};

export default BottomCtaModule;
